var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResultSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.58 20H11V60.66H68.58V20Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.7908 31.6395C23.7908 33.3695 22.3908 34.7595 20.6708 34.7595C18.9508 34.7595 17.5508 33.3595 17.5508 31.6395C17.5508 29.9195 18.9508 28.5195 20.6708 28.5195C22.3908 28.5195 23.7908 29.9195 23.7908 31.6395Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.7908 20.1094H17.5508V32.2694H23.7908V20.1094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.5681 31.6395C36.5681 33.3695 35.1681 34.7595 33.4481 34.7595C31.7281 34.7595 30.3281 33.3595 30.3281 31.6395C30.3281 29.9195 31.7281 28.5195 33.4481 28.5195C35.1681 28.5195 36.5681 29.9195 36.5681 31.6395Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.5798 20.1094H30.3398V32.2694H36.5798V20.1094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.3611 31.6395C49.3611 33.3695 47.9611 34.7595 46.2411 34.7595C44.5211 34.7595 43.1211 33.3595 43.1211 31.6395C43.1211 29.9195 44.5211 28.5195 46.2411 28.5195C47.9611 28.5195 49.3611 29.9195 49.3611 31.6395Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M49.3611 20.1094H43.1211V32.2694H49.3611V20.1094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M62.1502 31.6395C62.1502 33.3695 60.7502 34.7595 59.0302 34.7595C57.3102 34.7595 55.9102 33.3595 55.9102 31.6395C55.9102 29.9195 57.3102 28.5195 59.0302 28.5195C60.7502 28.5195 62.1502 29.9195 62.1502 31.6395Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M62.1502 20.1094H55.9102V32.2694H62.1502V20.1094Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.6117 31.6398C17.6117 33.4598 16.1317 34.9398 14.3117 34.9398C12.4917 34.9398 11.0117 33.4598 11.0117 31.6398C11.0117 29.8198 12.4917 28.3398 14.3117 28.3398C16.1317 28.3398 17.6117 29.8198 17.6117 31.6398Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M17.55 20.1094H11V31.6494H17.55V20.1094Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M30.3891 31.6398C30.3891 33.4598 28.9091 34.9398 27.0891 34.9398C25.2691 34.9398 23.7891 33.4598 23.7891 31.6398C23.7891 29.8198 25.2691 28.3398 27.0891 28.3398C28.9091 28.3398 30.3891 29.8198 30.3891 31.6398Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M30.3391 20.1094H23.7891V31.6494H30.3391V20.1094Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M43.1781 31.6398C43.1781 33.4598 41.6981 34.9398 39.8781 34.9398C38.0581 34.9398 36.5781 33.4598 36.5781 31.6398C36.5781 29.8198 38.0581 28.3398 39.8781 28.3398C41.6981 28.3398 43.1781 29.8198 43.1781 31.6398Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M43.1203 20.1094H36.5703V31.6494H43.1203V20.1094Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M55.9711 31.6398C55.9711 33.4598 54.4911 34.9398 52.6711 34.9398C50.8511 34.9398 49.3711 33.4598 49.3711 31.6398C49.3711 29.8198 50.8511 28.3398 52.6711 28.3398C54.4911 28.3398 55.9711 29.8198 55.9711 31.6398Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M55.9094 20.1094H49.3594V31.6494H55.9094V20.1094Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M65.49 34.9457C67.3123 34.9212 68.7698 33.424 68.7453 31.6016C68.7208 29.7793 67.2236 28.3218 65.4013 28.3463C63.5789 28.3708 62.1214 29.868 62.1459 31.6903C62.1704 33.5127 63.6676 34.9702 65.49 34.9457Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M68.7584 20.1094H62.1484V31.6494H68.7584V20.1094Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M45 60.8809V40.8809H60V60.8809",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M36.8883 41.3203H17.2383V51.9203H36.8883V41.3203Z",
    fill: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultSearch);
export default __webpack_public_path__ + "static/media/no-result-search.78caa0f216fec1d25d7ecdcd88623a79.svg";
export { ForwardRef as ReactComponent };